import * as React from 'react';
import { InputModalHost } from 'ui/common/prompt-confirmation/input-modal-host';
import { UnlockCaseModal } from './unlock-case-modal';

export const UnlockCase = props => (

  <InputModalHost {...props}>
  {
    modalProps => modalProps.isOpen
      ?
        <UnlockCaseModal {...props} {...modalProps} />
      :        
        typeof props.children === 'function' ? props.children(modalProps) : null
  }
  </InputModalHost>
);
